import React, { useRef } from "react";

type DateInputProps = React.InputHTMLAttributes<HTMLInputElement>;

/**
 * Date field that opens its calendar when the whole control is clicked.
 * Browsers only open the picker from the small calendar icon by default.
 */
const DateInput: React.FC<DateInputProps> = ({ onClick, ...props }) => {
  const ref = useRef<HTMLInputElement>(null);

  function openPicker(e: React.MouseEvent<HTMLInputElement>) {
    const el = ref.current as (HTMLInputElement & { showPicker?: () => void }) | null;
    if (el && typeof el.showPicker === "function") {
      try {
        el.showPicker();
      } catch (err) {
        // Not supported, or the browser refused outside a user gesture.
      }
    }
    if (onClick) onClick(e);
  }

  return <input {...props} type="date" ref={ref} onClick={openPicker} />;
};

export default DateInput;
